(function () {
  const SELECTOR = '.js-top-bar-rotated-texts';

  if (window.__topBarRotatedTextsScriptLoaded) return;
  window.__topBarRotatedTextsScriptLoaded = true;

  const isInEditor = !!(window.Shopify && Shopify.designMode);

  const initializeTopBarRotatedTexts = () => {
    const sliders = document.querySelectorAll(`${SELECTOR}:not(.is-splide-init)`);

    sliders.forEach((element) => {
      element.classList.add('is-splide-init');

      const intervalAttr = element.getAttribute('data-slide-interval');
      const interval = parseInt(intervalAttr, 10) || 3000;

      const splide = new Splide(element, {
        direction: 'ttb',
        height: '21px',
        autoplay: !isInEditor, 
        interval: interval,
        rewind: true,
        arrows: false,
        pagination: false
      });

      splide.mount();

      element.__splide = splide;
    });
  };

  document.addEventListener('DOMContentLoaded', initializeTopBarRotatedTexts);
  document.addEventListener('shopify:section:load', initializeTopBarRotatedTexts);
  document.addEventListener('shopify:section:reorder', initializeTopBarRotatedTexts);
  document.addEventListener('shopify:section:select', initializeTopBarRotatedTexts);
  document.addEventListener('shopify:block:select', initializeTopBarRotatedTexts);
  document.addEventListener('shopify:block:deselect', initializeTopBarRotatedTexts);

  document.addEventListener('shopify:block:select', (event) => {
    const detail = event.detail || {};
    const blockId = detail.blockId;
    if (!blockId) return;

    let block =
      document.querySelector('[data-block-id="' + blockId + '"]') ||
      document.getElementById('shopify-block-' + blockId) ||
      document.getElementById(blockId);

    if (!block && detail.el) {
      block = detail.el;
    }
    if (!block) return;

    const slider = block.closest(SELECTOR);
    if (!slider) return;

    const splide = slider.__splide || slider.splide;
    if (!splide) return;

    let slide = block.closest('.splide__slide');
    if (!slide && block.classList.contains('splide__slide')) {
      slide = block;
    }
    if (!slide) return;

    const slides = Array.from(slider.querySelectorAll('.splide__slide'));
    const index = slides.indexOf(slide);
    if (index === -1) return;

    splide.go(index);
  });
})();